import firebase from "firebase/app";
import "firebase/firestore";

import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card";
import { CreateElement } from "vue";

import "@/firebase";
import { db, questionnaireCollection } from "@/firebase";
import GlobalAuth from "./rules";

@Component
export default class Questionnaire extends Vue {
  @Prop() callbackOnComplete!: (callbackToSubmitQuestionnaire: any) => void;
  @Prop() backToStudentInfo!: () => void;
  private rules = GlobalAuth;

  private yesno = ["Yes", "No", "I don't know"];
  private native = [
    "No",
    "Yes, First Nations",
    "Yes, Metis",
    "Yes, Inuit",
    "Yes, Other Indigenous peoples"
  ];
  private support = [
    "Yes",
    "No, I don't need any support",
    "No, but I want support"
  ];

  private input: any = {};

  private _inputValid: boolean = false;

  created() {
    window.scrollTo(0, 0);
  }

  render(h: CreateElement) {
    return (
      <v-container class="fill-height" fluid>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="accent" dark flat>
                <v-toolbar-title>Student Questionnaire</v-toolbar-title>
              </v-toolbar>
              <v-form ref="form" v-model={this._inputValid}>
                <v-card-text>
                  Which country do you live in?
                  <v-text-field
                    label="Country"
                    name="country"
                    rules={this.rules.textRules}
                    type="text"
                    v-model={this.input["country"]}
                    required
                    autocomplete
                  ></v-text-field>
                  Which city do you live in?
                  <v-text-field
                    label="City"
                    name="city"
                    rules={this.rules.textRules}
                    type="text"
                    v-model={this.input["city"]}
                    required
                    autocomplete
                  ></v-text-field>
                  Were you born in Canada?
                  <v-select
                    name="bornInCanada"
                    v-model={this.input["bornInCanada"]}
                    items={this.yesno}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  {this.input["bornInCanada"] == "No" ? (
                    <span>
                      If you were not born in Canada, how old were you when you
                      moved to Canada?
                      <v-text-field
                        label="Age"
                        name="moveInAge"
                        rules={this.rules.integerRules}
                        type="number"
                        min={0}
                        v-model={this.input["moveInAge"]}
                        required
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )}
                  Do you identify as First Nations, Metis, or Inuit?
                  <v-select
                    name="native"
                    v-model={this.input["native"]}
                    items={this.native}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  Is English your first language?
                  <br></br>
                  First langauge is the language that you are the most
                  comfortable using.
                  <v-select
                    name="firstLanguage"
                    v-model={this.input["firstLanguage"]}
                    items={this.yesno}
                    required
                    rules={this.rules.required}
                  ></v-select>
                  {this.input["firstLanguage"] == "No" ? (
                    <div>
                      If no, what is your first language?
                      <v-text-field
                        label="First Language"
                        name="first_language"
                        rules={this.rules.textRules}
                        type="text"
                        min={0}
                        v-model={this.input["first_language"]}
                        required
                        autocomplete
                      ></v-text-field>
                      Have you taken any English language learning class (e.g.
                      ESL)
                      <v-select
                        name="eslClasses"
                        v-model={this.input["eslClasses"]}
                        items={this.yesno}
                        rules={this.rules.required}
                        required
                      ></v-select>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* {this.input['eslClasses'] == 'Yes' ? (
										<span>
											{/* How many English language learning
											classes have you taken?
											<v-text-field
												label='Number of Classes'
												name='numEslClasses'
												rules={this.rules.integerRules}
												type='number'
												min={0}
												v-model={
													this.input['numEslClasses']
												}
												required
												autocomplete
											></v-text-field> 
											How old were you when you first took
											an English language learning class?
											<v-text-field
												label='Age'
												name='firstEslAge'
												rules={this.rules.integerRules}
												type='number'
												min={0}
												v-model={
													this.input['firstEslAge']
												}
												required
												autocomplete
											></v-text-field>
										</span>
									) : (
										''
									)} */}
                  Which language(s) do you speak at home? List all the languages
                  you speak at home.
                  <v-text-field
                    label="Languages Spoken"
                    name="spokenLanguages"
                    rules={this.rules.listRules}
                    type="text"
                    v-model={this.input["spokenLanguages"]}
                    autocomplete
                  ></v-text-field>
                  Which language(s) do you hear at home? List all the languages
                  you hear at home.
                  <v-text-field
                    label="Languages Heard"
                    name="heardLanguages"
                    rules={this.rules.listRules}
                    type="text"
                    v-model={this.input["heardLanguages"]}
                    autocomplete
                  ></v-text-field>
                  <br></br>
                  {/* <p>
                    BalanceAI is designed to provide support for students'
                    learning, so we'd like to know about your learning
                    experience.
                  </p>
                  <br></br> */}
                  {/* Do you have any difficulties with learning?
                  <v-select
                    name="hasDifficultyLearning"
                    v-model={this.input["hasDifficultyLearning"]}
                    items={this.yesno}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  Have you been formally diagnosed for learning difficulties?
                  <v-select
                    name="formallyDiagnosed"
                    v-model={this.input["formallyDiagnosed"]}
                    items={this.yesno}
                    // rules={this.rules.required}
                    required
                  ></v-select>
                  {this.input["formallyDiagnosed"] == "Yes" ? (
                    <span>
                      Describe any known learning difficulty diagnoses.
                      <v-text-field
                        label="Learning Difficulty Diagnoses"
                        name="difficultyDiagnoses"
                        rules={this.rules.listRules}
                        type="text"
                        v-model={this.input["difficultyDiagnoses"]}
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )}
                  {this.input["hasDifficultyLearning"] == "Yes" ? (
                    <span>
                      Are you getting any support for your difficulties with
                      learning?
                      <v-select
                        name="hasSupport"
                        v-model={this.input["hasSupport"]}
                        items={this.support}
                        required
                        rules={this.rules.required}
                      ></v-select>
                    </span>
                  ) : (
                    ""
                  )}
                  {this.input["hasDifficultyLearning"] == "Yes" &&
                  this.input["hasSupport"] == "Yes" ? (
                    <span>
                      Please list any learning supports you have.
                      <v-text-field
                        label="Learning Supports"
                        name="learningSupports"
                        rules={this.rules.listRules}
                        type="text"
                        v-model={this.input["learningSupports"]}
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )} */}
                </v-card-text>
              </v-form>
              <v-card-actions>
                <div class="flex-grow-1">
                  <v-btn onclick={this.backToStudentInfo}>Back</v-btn>
                </div>
                <v-btn
                  disabled={!this._formComplete()}
                  color="accent"
                  onclick={this._submitInfo}
                >
                  Complete Registration
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    );
  }
  private _formComplete() {
    let form = this.$refs.form as any;
    return form && form.validate();
  }

  private _submitInfo() {
    if (!this._formComplete()) return;

    let callbackUponUserCreation = () => {
      let currentUser = firebase.auth().currentUser;

      if (currentUser != null) {
        questionnaireCollection
          .doc(currentUser.uid)
          .set({
            ...this.input,
            ...{ dateSubmitted: Date.now() }
          })
          .then(() => {
            this.$store.dispatch("addNotification", {
              type: "success",
              value:
                "Questionnaire information stored successfully. \
                Registration complete.",
              timeout: 2500,
              icon: "mdi-account"
            });
            location.reload();
            this.$router.push({ name: "home" }).catch(err => {});
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              type: "error",
              value: "Failed to store questionnaire information. Try again",
              timeout: 5000,
              icon: "mdi-account"
            });
          });
      }
    };
    this.callbackOnComplete(callbackUponUserCreation.bind(this));
  }
}

const component = Questionnaire;
